<template>
  <div>
    <div class="text-link-lists">
      <TextLinkListExpand text="テキストリンクリスト（expand）" :border="true">
        <SampleTextLinkListExpandBody />
      </TextLinkListExpand>
      <TextLinkListExpand
        text="テキストリンクリスト（expand2）"
        background-color="gray-3"
        chevron-color="link"
        :bold="true"
      >
        <SampleTextLinkListExpandBody2
          v-bind="sampleTextLinkListExpandBody2Props"
        />
      </TextLinkListExpand>
    </div>
  </div>
</template>
<script>
import TextLinkListExpand from '../../components/molecules/text_link_lists/TextLinkListExpand'
import SampleTextLinkListExpandBody from './sample-text-link-list-expand-body'
import SampleTextLinkListExpandBody2 from './sample-text-link-list-expand-body-2'

export default {
  components: {
    TextLinkListExpand,
    SampleTextLinkListExpandBody,
    SampleTextLinkListExpandBody2
  },
  data() {
    return {
      sampleTextLinkListExpandBody2Props: {
        textLinkListProps: [
          {
            text: 'テキストリンクリスト（gray-3）',
            border: true,
            backgroundColor: 'gray-3',
            href: '/'
          },
          {
            text: 'テキストリンクリスト（gray-3・下線なし）',
            backgroundColor: 'gray-3',
            href: '/'
          }
        ]
      }
    }
  }
}
</script>
